import { getAppInstance } from '@/utils/api/app';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '@zopauk/nextjs-auth';
import { AxiosResponse, AxiosError } from 'axios';
import { GetMemberResponse } from '@zopauk/api-membership-hub';

export const useQueryMember = () => {
  const { data: session } = useSession();

  return useQuery<AxiosResponse<GetMemberResponse>, AxiosError>({
    queryFn: () => getAppInstance().get('/members/me'),
    queryKey: ['member', session?.user.memberId],
    enabled: !!session,
  });
};
